const resTypeOptions = [
  {
    value: "1",
    label: "文字"
  },
  {
    value: "2",
    label: "口述"
  },
  {
    value: "3",
    label: "音乐"
  },
  {
    value: "4",
    label: "戏剧"
  },
  {
    value: "5",
    label: "曲艺"
  },
  {
    value: "6",
    label: "舞蹈"
  },
  {
    value: "7",
    label: "杂技"
  },
  {
    value: "8",
    label: "美术"
  },
  {
    value: "9",
    label: "建筑"
  },
  {
    value: "10",
    label: "摄影"
  },
  {
    value: "11",
    label: "电影"
  },
  {
    value: "12",
    label: "类似摄制电影方法创作作品"
  },
  {
    value: "13",
    label: "工程设计图、产品设计图"
  },
  {
    value: "15",
    label: "地图、示意图"
  },
  {
    value: "17",
    label: "模型"
  },
  {
    value: "181",
    label: "其他作品"
  }
]
export default resTypeOptions